import { Select, Input, Popover } from 'antd'
const { TextArea } = Input
import styles from './TypeMessage.module.scss'
import { GrAttachment } from 'react-icons/gr'
import { LuSend } from 'react-icons/lu'
import { IoMicOutline } from 'react-icons/io5'
import { FaRegCircleStop } from 'react-icons/fa6'
import { GrDocumentText } from 'react-icons/gr'
import { TbPhotoStar } from 'react-icons/tb'
import { IoCamera } from 'react-icons/io5'
import { FiHash } from 'react-icons/fi'
import { MdDeleteOutline } from "react-icons/md";
import { get, update, ref, push, onValue } from 'firebase/database'
import {
  getDownloadURL,
  uploadBytesResumable,
} from 'firebase/storage'
import { database, storageRef, storage } from 'utils/firebase'
import { Flex, Progress } from 'antd'
import { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux'

const TypeMessage = (props) => {
  const { patient } = props
  const [userMsg, setUserMsg] = useState('')
  const [message, setMessage] = useState([])
  const { currentSession, patientProfile } = useSelector(
    (state) => state.mentalHealth,
  )
  const { me } = useSelector((state) => state.app)
  const [selectedDocument, setSelectedDocument] = useState(null)
  const [uploadProgress, setUploadProgress] = useState(0)
  const [doctorData, setDoctorData] = useState(null)
  const [imageKey, setImageKey] = useState('')
  const [loading, setLoading] = useState(false)
  const [pictureKey, setPictureKey] = useState('')
  const [selectedPicture, setSelectedPicture] = useState(null)
  const [recording, setRecording] = useState(false)
  const [audioUrl, setAudioUrl] = useState(null)
  const [cannedResponse, setCannedResponse] = useState(null)
  const mediaRecorderRef = useRef(null)
  const audioChunksRef = useRef([])
  const intervalRef = useRef(null)
  const [timeArray, setTimeArray] = useState([])

  const inputRef = useRef(null)
  const pictureRef = useRef(null)
  const videoRef = useRef(null)
  const MAX_ARRAY_LENGTH = 15

  const handletextAreaChange = (e) => {
    const { value } = e.target
    setUserMsg(value)
  }

  // useEffect(() => {
  //   navigator.mediaDevices.getUserMedia({
  //     audio: {
  //       sampleRate: 8000,
  //       sampleSize: 8
  //     }
  //   })
  // }, [])

  const handleStartRecording = async () => {
    try {
      // const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: {
          sampleRate: 8000,
          sampleSize: 8
        }
      })
      // mediaRecorderRef.current = new MediaRecorder(stream)
      mediaRecorderRef.current = new MediaRecorder(stream, {
        mimeType: 'audio/mp4', // M4A MIME type
      });
      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data)
        }
      }
      mediaRecorderRef.current.onstop = () => {
        const audioBlob = new Blob(audioChunksRef.current, {
          // type: 'audio/aac',
          type: 'audio/mp4', // M4A format for the Blob

        })
        const audioUrl = URL.createObjectURL(audioBlob)
        setAudioUrl(audioUrl)
        audioChunksRef.current = []
        clearInterval(intervalRef.current)
      }
      mediaRecorderRef.current.start()
      setRecording(true)

      intervalRef.current = setInterval(() => {
        setTimeArray((prevArray) => {
          if (prevArray.length < MAX_ARRAY_LENGTH) {
            return [...prevArray, prevArray.length + 1]
          } else {
            clearInterval(intervalRef.current)
            return prevArray
          }
        })
      }, 1000)
    } catch (err) {
      console.error('Error accessing microphone:', err)
    }
  }

  const handleStopRecording = () => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state !== 'inactive'
    ) {
      mediaRecorderRef.current.stop()
    }
    setRecording(false)
    setTimeArray([])
    const stream = mediaRecorderRef.current.stream
    stream.getTracks().forEach((track) => track.stop())
  }

  const deleteVoiceNote = () => {
    // setAudioUrl(null)
    setUserMsg('')
    setAudioUrl(null)
    setLoading(false)
    setTimeArray([])
  }
  useEffect(() => {
    let cannedListener = null

    const getCannedResponse = ref(database, `/mh_canned_responses`)

    cannedListener = onValue(getCannedResponse, (snapshot) => {
      const cannedData = snapshot.toJSON()
      setCannedResponse(cannedData)
    })

    return () => {
      if (cannedListener) {
        cannedListener()
      }
    }
  }, [])

  const getDoctorDetail = async (docID) => {
    const doctorDetail = ref(database, `/doctors/${docID}`)

    try {
      const snapshot = await get(doctorDetail)
      if (snapshot.exists()) {
        const data = snapshot.toJSON()
        setDoctorData(data)
      } else {
        console.log('Nooo')
      }
    } catch (error) {
      console.error('Error fetching data in chat:', error)
    }
  }

  useEffect(() => {
    if (currentSession?.doctorID) {
      getDoctorDetail(currentSession?.doctorID)
    }
  }, [currentSession])

  const handleTagClick = (text) => {
    console.log("text", text);
    setUserMsg((prevUserMsg) => (prevUserMsg ? prevUserMsg + "\n\n" + text : text));
    // sendMessage(currentSession.conversationID)

  };

  useEffect(() => {
    try {
      if (currentSession?.conversationID) {
        const newChat = ref(
          database,
          `/mentalHealthConversations/${currentSession.conversationID}/`,
        )
        const newChatKey = push(newChat).key

        if (selectedDocument || selectedPicture) {
          setLoading(true)
          let imageType

          let type = null

          if (selectedDocument) {
            type = 'application'
          } else if (selectedPicture) {
            // Check if the selectedPicture is an image or video
            const fileType = selectedPicture.type.split('/')[0]; // Get "image" or "video"
            type = fileType === 'video' ? 'video' : 'image';

          }

          imageType = selectedDocument || selectedPicture

          const imageRef = storageRef(
            storage,
            `/mentalHealthConversations/${currentSession.conversationID
            }/${new Date().getTime()}`,
          )

          const uploadTask = uploadBytesResumable(imageRef, imageType)

          uploadTask.on(
            'state_changed',
            (snapshot) => {
              const progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              const roundedNumber = Math.round(progress)
              setUploadProgress(roundedNumber)
            },
            (error) => {
              console.log('Error uploading:', error)
              setLoading(false)
            },
            async () => {
              try {
                const resp = await getDownloadURL(imageRef)

                const updates = {}

                updates[
                  `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/content`
                ] = resp || null
                updates[
                  `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/timestamp`
                ] = Date.now()
                updates[
                  `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/type`
                ] = type
                updates[
                  `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/isRead`
                ] = false
                updates[
                  `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/doctorName`
                ] = doctorData?.doctorName
                updates[
                  `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/fromID`
                ] = currentSession?.doctorID || null
                updates[
                  `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/toID`
                ] = currentSession?.patientID || null

                update(ref(database), updates)
                  .then(() => {
                    console.log('Data updated')
                    setUserMsg('')
                    setImageKey(new Date().getTime().toString())
                    setSelectedPicture(null)
                    // setPictureKey(new Date().getTime().toString());
                    setSelectedDocument(null)
                    setLoading(false)
                  })
                  .catch((error) => {
                    console.log('Failed to update data:', error)
                    setLoading(false)
                  })
              } catch (error) {
                console.error('Error getting download URL:', error)
                setLoading(false)
              }
            },
          )
        }
      }
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }, [selectedDocument, selectedPicture])

  const sendMessage = async (id) => {
    const newChat = ref(database, `/mentalHealthConversations/${id}/`)
    const newChatKey = push(newChat).key

    if (audioUrl) {
      setLoading(true)

      const response = await fetch(audioUrl)
      const audioBlob = await response.blob()

      const audioRef = storageRef(
        storage,
        `/mentalHealthConversations/${currentSession.conversationID
        }/voice_note_${new Date().getTime()}.m4a`,
      )

      // const fileName = `voice_note_${Date.now()}.aac`;

      // const metadata = {
      //   contentType: 'audio/aac',
      //   customMetadata: {
      //     fileName,
      //     duration: audioBlob.size / 16000, // Approximation for duration
      //     recordedAt: new Date().toISOString(),
      //   },
      // };

      const uploadTask = uploadBytesResumable(audioRef, audioBlob)

      uploadTask.on(
        'state_changed',
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          const roundedNumber = Math.round(progress)
          setUploadProgress(roundedNumber)
        },
        (error) => {
          console.log('Error uploading:', error)
          setLoading(false)
        },
        async () => {
          try {
            const resp = await getDownloadURL(audioRef)

            const updates = {}

            updates[
              `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/content`
            ] = resp || null
            updates[
              `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/timestamp`
            ] = Date.now()
            updates[
              `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/type`
            ] = 'audio'
            updates[
              `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/duration`
            ] = audioBlob.size / 16000 // Approximation for duration
            updates[
              `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/isRead`
            ] = false
            updates[
              `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/doctorName`
            ] = doctorData?.doctorName
            updates[
              `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/fromID`
            ] = currentSession?.doctorID || null
            updates[
              `/mentalHealthConversations/${currentSession.conversationID}/${newChatKey}/toID`
            ] = currentSession?.patientID || null

            update(ref(database), updates)
              .then(() => {
                console.log('Data updated')
                setUserMsg('')
                setAudioUrl(null)
                setLoading(false)
              })
              .catch((error) => {
                console.log('Failed to update data:', error)
                setLoading(false)
              })
          } catch (error) {
            console.error('Error getting download URL:', error)
            setLoading(false)
          }
        },
      )
    }

    if (userMsg) {

      setLoading(true)
      const updates = {}
      updates[`/mentalHealthConversations/${id}/${newChatKey}/content`] =
        userMsg || null
      updates[`/mentalHealthConversations/${id}/${newChatKey}/timestamp`] =
        Date.now()
      updates[`/mentalHealthConversations/${id}/${newChatKey}/type`] = 'text'
      updates[`/mentalHealthConversations/${id}/${newChatKey}/isRead`] = false
      updates[`/mentalHealthConversations/${id}/${newChatKey}/doctorName`] =
        doctorData?.doctorName
      updates[`/mentalHealthConversations/${id}/${newChatKey}/fromID`] =
        currentSession?.doctorID || null
      updates[`/mentalHealthConversations/${id}/${newChatKey}/toID`] =
        currentSession?.patientID || null

      update(ref(database), updates)
        .then(() => {
          setLoading(false)
          setUserMsg('')
        })
        .catch((error) => {
          console.log('Failed to update data:', error)
          setLoading(false)
        })
    }
  }
  const content = (
    <div className={styles.attachmentContainer}>
      <div className={styles.attachmentButton}>
        <GrDocumentText
          color="#DF7467"
          size="17px"
          onClick={() => inputRef.current.click()}
        />
        <span onClick={() => inputRef.current.click()}>Document</span>
        <input
          id="document"
          name="document"
          ref={inputRef}
          type="file"
          style={{ display: 'none' }}
          accept=".pdf, .doc, .docx, .txt"
          key={imageKey}
          onChange={(event) => {
            setSelectedDocument(event.target.files[0])
          }}
        />
      </div>

      <div className={styles.attachmentButton}>
        <TbPhotoStar
          color="#DF7467"
          size="19px"
          onClick={() => pictureRef.current.click()}
        />
        <span onClick={() => pictureRef.current.click()}>Photo & Videos</span>

        <input
          id="picture"
          name="picture"
          ref={pictureRef}
          type="file"
          style={{ display: 'none' }}
          accept="image/*,video/*"  // Accepts both image and video files
          key={pictureKey}
          onChange={(event) => {
            setSelectedPicture(event.target.files[0])
          }}
        />

      </div>

      {/* <div className={styles.attachmentButton}>
                <IoCamera
                    color="#DF7467"
                    size="20px"

                />
                <span>Camera</span>


            </div> */}
    </div>
  )

  const tags = (
    <div className={styles.tagContainer}>
      {cannedResponse &&
        Object.entries(cannedResponse).map(([key, obj]) => (
          <span
            key={key}
            className={styles.tagss}
            onClick={() => handleTagClick(obj.text)}
          >
            {obj.shortcut}
          </span>
        ))}
    </div>
  )

  return (
    <div className={styles.messages}>
      <div className={styles.messageConatiner}>
        {loading ? (
          <>
            <div>
              <Flex gap="large" vertical style={{ width: 180 }}>
                <Progress
                  percent={uploadProgress}
                  size="large"
                  style={{ height: '20px', width: '100%', wordBreak: 'normal' }}
                />
              </Flex>
            </div>
          </>
        ) : (
          <>
            <div className={styles.attachment}>
              <Popover content={content}
                trigger={currentSession?.isArchive ? "" : "click"}
              // trigger="click"
              >
                <GrAttachment
                  style={{
                    cursor: currentSession?.isArchive ? "not-allowed" : "pointer", // Show disabled cursor
                    color: currentSession?.isArchive ? "#ccc" : "inherit", // Gray out if disabled
                  }}
                />
              </Popover>
            </div>

            {recording ? (
              <div className={styles.divCenter}>
                {timeArray.map((time, index) => (
                  <div className={styles.wave} key={index}></div>
                ))}
              </div>
            ) : audioUrl ? (
              <div className={styles.textAreaSize}>
                <audio controls src={audioUrl}></audio>
              </div>
            ) : (
              <TextArea
                className={styles.textAreaSize}
                autoSize={{ minRows: 2, maxRows: 15 }}
                autoFocus
                disabled={currentSession?.isArchive}
                placeholder="Type Message"
                onChange={handletextAreaChange}
                value={userMsg}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault()
                    sendMessage(currentSession.conversationID)
                  }
                }}
              />
            )}

            {!recording ? (
              <IoMicOutline
                // onClick={handleStartRecording}
                onClick={!currentSession?.isArchive ? handleStartRecording : ''}
                size={23}
                disabled={currentSession?.isArchive}
                color="#DF7467"
                style={{
                  cursor: currentSession?.isArchive ? "not-allowed" : "pointer", // Show disabled cursor
                  color: currentSession?.isArchive ? "#ccc" : "#DF7467", // Gray out if disabled
                }}
              />
            ) : (
              <FaRegCircleStop
                // onClick={handleStopRecording}
                onClick={!currentSession?.isArchive ? handleStopRecording : ''}
                size={23}
                color="#DF7467"
              />
            )}

            {audioUrl && (
              <MdDeleteOutline
                // onClick={handleStopRecording}
                onClick={!currentSession?.isArchive ? deleteVoiceNote : ''}
                size={23}
                color="#DF7467"
              />
            )}

            <div className={styles.sendMessage}>
              <LuSend
                // disabled={currentSession?.isArchive}
                // onClick={() => sendMessage(currentSession.conversationID)}
                onClick={
                  !currentSession?.isArchive
                    ? () => sendMessage(currentSession.conversationID)
                    : ''
                }
                color="#FFFFFF"
                style={{
                  cursor: currentSession?.isArchive ? "not-allowed" : "pointer", // Show disabled cursor
                  color: currentSession?.isArchive ? "#ccc" : "#FFFFFF", // Gray out if disabled
                }}
              />
            </div>
          </>
        )}
      </div>

      <div className={styles.hashTag}>
        <Popover disabled={currentSession?.isArchive} content={tags}
          trigger={currentSession?.isArchive ? "" : "click"}
        >
          <FiHash size={18} className={styles.canned}
            style={{
              cursor: currentSession?.isArchive ? "not-allowed" : "pointer", // Show disabled cursor
              color: currentSession?.isArchive ? "#ccc" : "inherit", // Gray out if disabled
            }}
          />
        </Popover>

        <span className={styles.addTag}> Add tags</span>
      </div>
    </div>
  )
}
export default TypeMessage
